import Vue from 'vue';
import URLManager from './URLManager';
import debounce from 'debounce';
import stAnalytics from './st-analytics';
import Promise from 'bluebird';
import StickySidebar from "sticky-sidebar";
import VueSlider from 'vue-slider-component'
import GoogleAnalytics from "./google-analytics";

document.addEventListener('DOMContentLoaded', function ($) {


    let st_app_id = 'UQMRWABQCTNM3FL3FS5V44YG';
    let st_app_read_token = '171HAJQRDWZXXB7J2XD2V1TL';
    let st_collection_id = 'P3MQ2DW95MUP9TF1KL78GRM3';
    let storeCurrencySymbol = 'Rs.';

    const baseUrl = `${window.location.protocol}//${window.location.host}`;

    st_app_id = baseUrl === 'https://us.koskii.com' ? 'TTTTETQPJGACT4X8JP4GGWPE' : 'UQMRWABQCTNM3FL3FS5V44YG';
    st_app_read_token = baseUrl === 'https://us.koskii.com' ? 'NLGDZP97ETTET31BUIX2GEN3' : '171HAJQRDWZXXB7J2XD2V1TL';
    st_collection_id = baseUrl === 'https://us.koskii.com' ? 'W4KRUK5N6CQJPH6K7QQTLX39' : 'P3MQ2DW95MUP9TF1KL78GRM3';
    storeCurrencySymbol = baseUrl === 'https://us.koskii.com' ? '$' : 'Rs.';


    const searchClient = new SearchClient(st_app_id, st_app_read_token);
    // const ga = new stAnalytics('gtag', 'prod', 'UA-78760227-2');

    let ga = new GoogleAnalytics("gtag", "G-CZYSDYJ076", false);

    const um = new URLManager(baseUrl);
    let sticky = {};
    let Currency = window.Currency;

    const BlueBird = Promise.noConflict();
    BlueBird.config({
        cancellation: true
    });

    let app = new Vue({
        el: '#searchModalContainer',
        directives: {},
        components: {
            VueSlider
        },
        data: {
            baseUrl: window.location.origin,
            errorEncountered: false,
            previousPageURL: window.location.href,
            previousPageTitle: document.title,
            isSearchPage: false,
            isOpen: false,
            totalHits: -1,
            backToTop: false,
            query: '',
            currency: storeCurrencySymbol,
            currencySymbol: storeCurrencySymbol,
            activeCurrency: 'INR',
            loader: true,
            sliderMin: 0,
            sliderMax: 0,
            sliderValue: [0, 0],
            sliderRange: [0, 0],
            previousRange: [0, 0],
            sliderChanged: false,
            showSliderReset: false,
            sliderDisable: false,
            pageSize: 16,
            currentRequest: undefined,
            results: [],
            bestSellerProducts: [],
            discountedProducts: [],
            resultsEnd: false,
            showBestSellers: false,
            showDiscountedProducts: false,
            scrollVal: 0,
            filterCount: 0,
            currOffset: 0,
            filters: [
                {
                    title: 'Collections',
                    field: "collections",
                    type: 'multiple',
                    isOpen: false,
                    values: [],
                    selected: [],
                    onTop: true,
                    isStatic: false
                },
                {
                    title: 'Price',
                    field: "discounted_price",
                    type: 'multiple_price',
                    isOpen: false,
                    values: [],
                    selected: [],
                    onTop: false,
                    isStatic: false
                },
                {
                    title: 'Fabric',
                    field: "meta_fabric",
                    type: 'multiple',
                    isOpen: false,
                    values: [],
                    selected: [],
                    onTop: false,
                    isStatic: false
                },
                {
                    title: 'Color',
                    field: "meta_color",
                    type: 'multiple',
                    isOpen: false,
                    values: [],
                    selected: [],
                    onTop: false,
                    isStatic: false
                },
                {
                    title: 'Karigari',
                    field: "meta_karigari",
                    type: 'multiple',
                    isOpen: false,
                    values: [],
                    selected: [],
                    onTop: false,
                    isStatic: false
                },
                {
                    title: 'Size',
                    field: "size",
                    type: 'multiple',
                    isOpen: false,
                    values: [],
                    selected: [],
                    onTop: false,
                    isStatic: false
                },
                {
                    title: 'Occasion',
                    field: "meta_occasions_array",
                    type: 'multiple',
                    isOpen: false,
                    values: [],
                    selected: [],
                    onTop: false,
                    isStatic: false
                },
                {
                    title: 'Product Type',
                    field: "meta_product_type",
                    type: 'multiple',
                    isOpen: false,
                    values: [],
                    selected: [],
                    onTop: false,
                    isStatic: false
                },
                {
                    title: "Discount",
                    field: "st_discount_filter",
                    type: "multiple",
                    isOpen: false,
                    values: [],
                    selected: [],
                    onTop: false,
                    isStatic: false,
                },

                /*{
                    title: 'Availability',
                    field: "isActive",
                    type: 'singleStatic',
                    isOpen: false,
                    values: ["Include out of Stock"],
                    selected: [],
                    onTop: false,
                    isStatic: true
                }*/
            ],
            sorts: [
                {
                    "label": "Relevance",
                    "field": ["-isActive", "-st_title_score", "searchtap_collection_position", "-_rank"]
                },
                {
                    "label": "Price: Low to High",
                    "field": ["-isActive", "discounted_price", "-_rank"]
                },
                {
                    "label": "Price: High to Low",
                    "field": ["-isActive", "-discounted_price", "-_rank"]
                },
                {
                    "label": "New Arrival",
                    "field": ["-isActive", "-created_at", "-_rank"]
                },
                {
                    "label": "Discount: Low to High",
                    "field": ["-isActive", "discount", "-_rank"]
                },
                {
                    "label": "Discount: High to Low",
                    "field": ["-isActive", "-discount", "-_rank"]
                },
                {
                    "label": "Customer Rating",
                    "field": ["-isActive", "-reviews_average", "-reviews_count", "-_rank"]
                },
            ],
            activeSortLabel: '',
            includeOutOfStock: false,
            showMobileFilter: false,
            activeMobileFilter: '',
            searchBoxSelector: document.querySelectorAll('input[name="q"]'),
            showAvailabilityFilter: true,
            collectionsToShow: [],
            collectionPageToOpen: '',
            isCollectionPage: false,
            bubbleFilterElement: document.querySelector('#st-scroll'),
            showWaitMsg: false,
            maxRetryCount: 2,
            crossElement: document.querySelectorAll(".input-close-btn-mobile"),
            waitMessage: 'It\'s taking longer than usual. Please check your network connection or try refreshing the page!'
        
        },

        methods: {

            search: function (offset, retryCount = 0) {

                searchClient
                    .fields("collections", "collections_handle", "created_at", "discount", "discounted_price", "handle", "images", "isActive", "isSearchable", "price", "product_type", "tags", "title", "variants", "hasMultiplePrice", "fabric", "occasion", "karigari", "color", "bundle", "size","judgeme_html")
                    .skip(offset)
                    .count(this.pageSize)
                    .filter()
                    .textFacets('collections', 'meta_fabric', 'meta_occasions_array', 'meta_karigari', 'meta_color', 'bundle', 'size', 'meta_product_type', 'st_discount_filter')
                    .facetCount(99)
                    .numericFacets("discounted_price", [])
                    .numericFacets("discount", [
                        {
                            min: 10,
                            max: 100,
                            minInclusive: true, //default true
                            maxInclusive: true, //default false
                        },
                        {
                            min: 20,
                            max: 100,
                            minInclusive: true, //default true
                            maxInclusive: true, //default false
                        },
                        {
                            min: 30,
                            max: 100,
                            minInclusive: true, //default true
                            maxInclusive: true, //default false
                        },
                        {
                            min: 40,
                            max: 100,
                            minInclusive: true, //default true
                            maxInclusive: true, //default false
                        },
                        {
                            min: 50,
                            max: 100,
                            minInclusive: true, //default true
                            maxInclusive: true, //default false
                        },
                        {
                            min: 60,
                            max: 100,
                            minInclusive: true, //default true
                            maxInclusive: true, //default false
                        },
                        {
                            min: 70,
                            max: 100,
                            minInclusive: true, //default true
                            maxInclusive: true, //default false
                        },
                        {
                            min: 80,
                            max: 100,
                            minInclusive: true, //default true
                            maxInclusive: true, //default false
                        },
                        {
                            min: 90,
                            max: 100,
                            minInclusive: true, //default true
                            maxInclusive: true, //default false
                        },
                    ]);

                app.currOffset = offset;
                app.filterCount = 0; // resetting filter count

                if (app.activeSortLabel) {
                    /***
                     * If current sort is relevance then
                     * If it's a collection page then sort results based on collection page specific ranking
                     * Else if it's a search page then sort results based on SearchTap ranking
                     */
                    let activeSortObj = JSON.parse(JSON.stringify(app.sorts.find(x => x.label === app.activeSortLabel)));
                    if (activeSortObj) {

                        if (app.activeSortLabel === 'Relevance' && app.isCollectionPage) {

                            if (activeSortObj.label === "Relevance") {
                                activeSortObj.field = activeSortObj.field.filter(item =>
                                    item !== "searchtap_collection_position" && !item.includes("-st_title_score")
                                );
                            }

                            /***
                             * replacing default rank with collection specific sorting
                             */
                            activeSortObj.field[activeSortObj.field.length - 1] = `${app.collectionPageToOpen.replace(/-/g, '_')}_position`;
                        }
                        searchClient.sort(...activeSortObj.field);
                    }
                }

                let resultsFilter = 'isSearchable = 1'.concat(app.includeOutOfStock ? '' : ' AND isActive = 1');
                /***
                 * If it's a collection page then filter results based on collection handle
                 */
                if (app.collectionPageToOpen) {
                    resultsFilter += ` AND collection_handles_shopify="${app.collectionPageToOpen}"`;
                }

                /***
                 * assigning text facet filter and numeric facet filter values
                 */
                app.filters.forEach(f => {
                    /***
                     * if it's a text facet filter and values are selected
                     */
                    if (f.type === 'multiple' && f.selected.length > 0) {
                        searchClient.textFacetFilters(f.field, f.selected);
                        app.filterCount += f.selected.length;
                    }
                        /***
                         * if it's a text facet filter and values are selected
                         */
                        else if (f.type === 'multiple_price' && f.selected.length > 0 && f.title !== 'Price') {
                           f.selected.forEach(s => {
                               searchClient.numericFacetFilters(f.field, s[0], s[1]);
                           });
                           app.filterCount += f.selected.length;
                    }
                    else if (f.isStatic && app.includeOutOfStock) {
                        app.filterCount += 1;
                    }
                });

                /***
                 * Using slider values in numeric facet filter
                 */
                // if (app.sliderValue[0] !== 0 && app.sliderValue[1] !== 0 && app.sliderValue[0] !== "" && app.sliderValue[1] !== "" && app.sliderValue[0] !== app.sliderValue[1] && ((/^\d+$/.test(app.sliderValue[0])) || (/^\d+$/.test(app.sliderValue[1]))) && app.showSliderReset) {
                if (app.sliderValue[0] !== 0 && app.sliderValue[1] !== 0 && app.sliderValue[0] !== "" && app.sliderValue[1] !== "" && app.sliderValue[0] !== app.sliderValue[1] && app.showSliderReset) {
                    searchClient.numericFacetFilters("discounted_price", this.revertPrice(app.sliderValue[0]), this.revertPrice(app.sliderValue[1]));
                }

                if (resultsFilter.trim()) searchClient.filter(resultsFilter);
                /***
                 * Cancel Promise if it's in pending state
                 */
                if (app.currentRequest && app.currentRequest.isPending()) {
                    app.currentRequest.cancel();
                }

                app.currentRequest = BlueBird.resolve().then(x => {
                    return searchClient.search(app.query.trim(), st_collection_id);
                });

                app.currentRequest.then(function (data) {

                    if (data) {

                        setTimeout(() => {
                            sticky.updateSticky();
                        }, 100);

                        //Inconsistent because this will only happen on absurd query like 'asdfsfdfsdafsafv'
                        app.sliderDisable = !(/^[+-]?\d+(\.\d+)?$/.test(data.stats.discounted_price.max)) || !(/^[+-]?\d+(\.\d+)?$/.test(data.stats.discounted_price.min));
                        // app.sliderDisable = data.totalHits === 0

                        app.sliderMin = app.convertPrice(data.stats.discounted_price.min);
                        app.sliderMax = app.convertPrice(data.stats.discounted_price.max);
                        app.sliderRange = [app.sliderMin, app.sliderMax];
                        if (!app.sliderChanged) {
                            app.sliderValue = [app.convertPrice(data.stats.discounted_price.min), app.convertPrice(data.stats.discounted_price.max)];
                        }
                        /*if(app.sliderChanged){
                            app.sliderValue = [app.convertPrice(data.query.numericFacetFilters.discounted_price[0]), app.convertPrice(data.query.numericFacetFilters.discounted_price[1])]
                        }*/
                        //not to be replaced by !===
                        app.showSliderReset = app.sliderValue[0] != app.sliderMin || app.sliderValue[1] != app.sliderMax

                        /***
                         * Resetting properties
                         */
                        if (app.errorEncountered) app.errorEncountered = false;
                        if (app.loader) app.loader = false;
                        if (app.showDiscountedProducts) app.showDiscountedProducts = false;
                        if (app.showBestSellers) app.showBestSellers = false;
                        app.discountedProducts.length = 0
                        app.bestSellerProducts.length = 0;

                        app.totalHits = data.totalHits;
                        app.showWaitMsg = false;

                        if (offset === 0) {

                            app.results = data.results;
                            /***
                             * Resetting scrolls
                             */
                            app.scrollVal = 0;
                            if (app.bubbleFilterElement) app.bubbleFilterElement.scroll({left: 0});
                            if (window.scrollY > 200) app.goToTop();
                        } else {
                            app.results = app.results.concat(data.results);
                        }

                        app.resultsEnd = app.results.length > 0 && app.results.length === app.totalHits;
                        /***
                         * If there are no results and
                         * If there are no filters selected then
                         * show the bestsellers and discounted products
                         */
                        if (app.totalHits === 0 && app.filterCount === 0) {
                            app.showBestSellers = true;
                            app.getBestSellers();

                            app.showDiscountedProducts = true;
                            app.getDiscountedProducts();
                        }
                        /***
                         * Assign SearchTap response text facet filter values to each filter
                         */
                        app.filters.filter(x => !x.isStatic).forEach(f => {

                            let filterList = document.getElementById(`${f.field}FilterValues`);
                            // if (filterList) filterList.scrollTop = 0;

                            f.values = [];
                            let fd = data.textFacets[f.field];

                            if (f.field === 'color') fd.sort(app.compareValues('label'));

                            if (fd && fd.length > 0) {
                                if (f.field === 'collections') {
                                    /***
                                     * show collections only that are mentioned by the Koskii team
                                     */
                                    app.filterCollections(f, fd);
                                } else {
                                    fd.forEach(v => {
                                        f.values.push({
                                            name: v.label,
                                            count: v.value
                                        });
                                    });
                                }
                                /***
                                 * Size sorting
                                 */
                                if (f.title === 'Size') {

                                    function findAndPrepend(input) {
                                        let val = f.values.find(x => x.name === input);
                                        if (val) {
                                            f.values.splice(f.values.indexOf(val), 1);
                                            f.values.push(val);
                                        }
                                    }

                                    findAndPrepend('O/S');
                                    findAndPrepend('XS');
                                    findAndPrepend('S');
                                    findAndPrepend('M');
                                    findAndPrepend('L');
                                    findAndPrepend('XL');
                                    findAndPrepend('XXL');
                                }

                                if (f.field === "st_discount_filter") {
                                    const customOrder = [
                                        "Upto 50% Off",
                                        "Buy 2 get 25% | 3+ get 30% Off",
                                        "30% & above",
                                        "40% & above",
                                        "50% & above"
                                    ];

                                    f.values = f.values.filter(v => v.name !== "20% & above");

                                    f.values.sort((a, b) => {
                                        return customOrder.indexOf(a.name) - customOrder.indexOf(b.name);
                                    });
                                }
                            }
                            /***
                             * Numeric facet filter values
                             */
                            let numericFacetValues = data.numericFacets[f.field];
                            if (numericFacetValues && numericFacetValues.length > 0) {
                                numericFacetValues.forEach(v => {
                                    if (v.count > 0) {
                                        f.values.push({
                                            min: v.min.toString(),
                                            max: v.max.toString(),
                                            count: v.count
                                        });
                                    }
                                });
                            }
                        });

                        setTimeout(() => {
                            if(typeof(initButtons) !== 'undefined') initButtons();
                        },800);

                    } else {
                        throw new Error("Response data undefined");
                    }
                }).catch((e) => {
                    if (retryCount < app.maxRetryCount) {
                        app.search(offset, ++retryCount);
                    } else {
                        app.showWaitMsg = true;
                        console.error(`SearchTap Error: ${e}`);
                    }
                });
            },

            compareValues: function (key, order = 'asc') {
                return function innerSort(a, b) {
                    if (!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) {
                        // property doesn't exist on either object
                        return 0;
                    }

                    const varA = (typeof a[key] === 'string')
                        ? a[key].toUpperCase() : a[key];
                    const varB = (typeof b[key] === 'string')
                        ? b[key].toUpperCase() : b[key];

                    let comparison = 0;
                    if (varA > varB) {
                        comparison = 1;
                    } else if (varA < varB) {
                        comparison = -1;
                    }
                    return (
                        (order === 'desc') ? (comparison * -1) : comparison
                    );
                };
            },

            filterCollections: function (filter, textFacetValues) {

                app.collectionsToShow.forEach(x => {

                    let specificValue = textFacetValues.find(y => y.label.toLowerCase().trim() === x.value);
                    if (specificValue) {
                        filter.values.push({
                            displayName: x.label,
                            name: specificValue.label,
                            count: specificValue.value
                        });
                    }
                })
            },

            getBestSellers: function () {

                let count = 4;
                if (app.isDeviceMobile()) count = 2;
                else if (app.isDeviceIPad()) count = 3;

                searchClient
                    .fields('*')
                    .skip(0)
                    .count(count)
                    .filter("isSearchable = 1 AND collections = 'koskii-bestsellers'");

                searchClient.search('', st_collection_id).then((data) => {

                    if (data) {
                        app.bestSellerProducts = data.results;
                        app.$forceUpdate();
                    }
                });
            },

            getDiscountedProducts: function () {

                let count = 4;
                if (app.isDeviceMobile()) count = 2;
                else if (app.isDeviceIPad()) count = 3;

                searchClient
                    .fields('*')
                    .skip(0)
                    .count(count)
                    .filter("isSearchable = 1 AND collections = 'sale'");

                searchClient.search('', st_collection_id).then((data) => {

                    if (data) {
                        app.discountedProducts = data.results;
                        app.$forceUpdate();
                    }
                });
            },

            getCollectionDisplayName: function (filter, selectedValue) {
                /***
                 * Return collection display name
                 */
                let val1 = filter.values.find(x => x.name === selectedValue);
                if (val1) return val1.displayName;

                let val2 = this.collectionsToShow.find(x => x.value === selectedValue);
                if (val2) return val2.label;

                return selectedValue;
            },

            init: function () {
                /***
                 * set active mobile filter to first non bubble filter
                 */
                if (!app.activeMobileFilter) app.activeMobileFilter = this.filters.find(x => x.onTop === false).field;
                /***
                 * set default sort label to first sort label
                 */
                if (!app.activeSortLabel) app.activeSortLabel = app.sorts[0].label;
                /***
                 * check whether to show availability filter or not
                 */
                app.setAvailabilityFilterVisibility();
                /***
                 * filter display collection values
                 */
                if (st_collections) {
                    this.collectionsToShow = st_collections.map(x => {
                        x.value = x.value.toLowerCase().trim();
                        return x;
                    });
                }

                /***
                 * If it's search page then open search modal
                 * Else check for collection page and set collection handle
                 */
                let url = window.location.href;

                if (location.hostname === 'www.koskii.com' && url.includes('/search')) {
                    app.isSearchPage = true;
                    app.openSearchModal();
                    app.getSearchParamsFromUrl(url);
                    app.search(0);
                } else {
                    app.checkAndOpenCollectionsPage();
                    if (app.isCollectionPage) app.search(0);
                }

                /***
                 * Check if query exist in input box
                 * If yes, then fire keyup evemt
                 */
                app.searchBoxSelector.forEach(searchElement => {
                    if (searchElement.value.trim() && !app.isSearchPage) {
                        if(window.location.host !== 'webcache.googleusercontent.com')app.handleKeyup(searchElement);
                    }
                });

                app.setSidebarSticky();
            },

            setAvailabilityFilterVisibility: function () {
                /***
                 * if showAvailabilityFilter is false then filter out availability from the filters array
                 */
                if (st_show_availability_filter && typeof st_show_availability_filter === "boolean") {

                    this.showAvailabilityFilter = st_show_availability_filter;

                    if (!this.showAvailabilityFilter) {
                        this.filters = this.filters.filter(x => !x.isStatic);
                    }
                }
            },

            getSearchParamsFromUrl(url, cachedPage = false) {

                let res = um.parseUrl(url);

                // if state is null
                if (res.load) {
                    location.reload();
                }

                // add query
                let q = res.query;

                if (q && !cachedPage) {

                    app.query = q;
                    document.title = app.query + "-Koskii";
                    app.searchBoxSelector.forEach(x => {
                        x.value = app.query;
                    })
                    um.withQuery(app.query);
                }

                if (app.query !== "") {
                    app.crossElement.forEach(x => x.style.display = 'inline-block');
                }

                // add sort
                let sort = res.sort;
                if (sort) {
                    app.activeSortLabel = app.sorts.find(x => x.field.toString() === sort).label;
                    um.withSort(app.sorts.find(x => x.label === app.activeSortLabel).field);
                } else {
                    app.activeSortLabel = app.sorts[0].label;
                }

                // add filters
                um.clearFilterParams();
                app.emptyPushedFilters();
                let urlFilter = res.filters;
                if (urlFilter && (JSON.stringify(urlFilter) !== '{}')) {
                    let fields = Object.keys(urlFilter);
                    app.filters.forEach(o => {
                        fields.forEach(f => {
                            if (o.title === f) {
                                if (o.type === 'multiple' || o.type === 'singleStatic') {
                                    o.selected = urlFilter[f].map(x => {
                                        return decodeURIComponent(x);
                                    })
                                    um.withFilters(o.title, o.selected);
                                } else if (o.type === 'multiple_price') {
                                    for (let val of urlFilter[f]) {
                                        o.selected.push(val.replace(/ /g, '').split('-'));
                                    }
                                    um.withNumericFilters(o.title, o.selected);
                                }
                            }
                        })
                    });
                }

                //add range
                let range = res.ranges;
                if (range && (JSON.stringify(range) !== '{}')) {
                    app.sliderValue[0] = app.convertPrice(parseFloat(range.Price.from));
                    app.sliderValue[1] = app.convertPrice(parseFloat(range.Price.to));
                    app.sliderChanged = true;
                    app.showSliderReset = true;
                    this.$refs.slider.setValue(app.sliderValue);
                    this.$refs.mobileSlider[0].setValue(app.sliderValue);
                } else {
                    app.sliderValue[0] = parseFloat(app.sliderMin);
                    app.sliderValue[1] = parseFloat(app.sliderMax);
                    app.sliderChanged = false;
                }
                // app.sliderChanged = false;
            },

            pushQuery: debounce(function () {

                if (app.isOpen && app.query) {
                    let res = um.withQuery(app.query);
                    let stateObj = res.currentUrl;
                    ga.recordQuery(app.query);
                    history.pushState(stateObj, 'query', stateObj);
                }
            }, 500),

            loadMore: function () {
                if (app.currentRequest && app.currentRequest.isPending())
                    return undefined;
                else
                    this.search(app.currOffset + app.pageSize);
            },

            checkTagCondition: function (product, tag) {
                return product.tags.indexOf(tag) > -1;
            },

            // checkFlatTags: function(tagsArr) {
            //     let foundTag = tagsArr.find(tag => tag.toLowerCase().includes('flatoffer_'));
            //     if(foundTag) {
            //        return foundTag.split('flatoffer_')[1];
            //     }
            // },

            // checkFlatTags: function(tagsArr) {
            //        let foundTag = tagsArr.find(tag => tag.toLowerCase().includes('_online_flat_'));
            //        if (foundTag) {
            //        let match = foundTag.match(/flat_(\d+)_off/i);
            //        if (match && match[1]) {
            //        return match[1];
            //        }
            //     }
            //        return null;
            // },

//             checkFlatTags: function(tagsArr, baseUrl) {
//     let pattern = baseUrl === 'https://us.koskii.com'
//         ? /_online_international_flat_(\d+)_off/i
//         : /_online_flat_(\d+)_off/i;

//     let foundTag = tagsArr.find(tag => pattern.test(tag));
//     if (foundTag) {
//         let match = foundTag.match(pattern);
//         if (match && match[1]) {
//             return `${match[1]}`;
//         }
//     }
//     return null;
// },

       checkFlatTags: function(tagsArr) {
    const baseUrl = this.baseUrl;

    if (baseUrl === 'https://us.koskii.com') {
        // Only consider international tag
        const intlTag = tagsArr.find(tag => /_online_international_flat_(\d+)_off/i.test(tag));
        if (intlTag) {
            const match = intlTag.match(/_online_international_flat_(\d+)_off/i);
            return match && match[1] ? match[1] : null;
        }
    } else {
        // Only consider local tag
        const localTag = tagsArr.find(tag => /_online_flat_(\d+)_off/i.test(tag));
        if (localTag) {
            const match = localTag.match(/_online_flat_(\d+)_off/i);
            return match && match[1] ? match[1] : null;
        }
    }

    return null;
},


            getProductUrl: function (handle) {
                if (handle) {
                    return `${window.location.origin}/products/${handle}`
                }

            },

            prodUrl: function (title) {
                ga.recordProductViewedEvent(title);
            },

            imgResizer: function (img, size = 'large') {

                if (img && img.src) {
                    let srcImage = img.src;
                    let separatorIndex = srcImage.lastIndexOf('.');
                    return `${srcImage.slice(0, separatorIndex)}_${size.toLowerCase()}${srcImage.slice(separatorIndex)}`;
                } else {
                    return null
                }
            },

            bubbleFilterScroll: function (scrollMod) {

                let scrollHandle = 0;
                let parent = document.querySelector("#st-scroll");
                let scrollStep = 700;

                let direction = parseInt(scrollMod, 10);

                if (scrollHandle === 0) {
                    scrollHandle = 1;
                    let newOffset = parent.scrollLeft + (scrollStep * direction);
                    parent.scroll({
                        left: newOffset,
                        behavior: 'smooth'
                    });
                }
                clearInterval(scrollHandle);
                scrollHandle = 0;
            },

            sorting: function () {

                if (app.activeSortLabel !== "Relevance") {
                    ga.recordSortEvent(app.activeSortLabel);
                }

                let res = um.withSort(app.sorts.find(x => x.label === app.activeSortLabel).field);
                let stateObj = res.currentUrl;
                history.pushState(stateObj, 'sort', stateObj);
                if (app.showSliderReset) app.sliderChange();
                // app.sliderChanged = false;
                app.search(0);
            },

            getNotSelectedFilters: function (field) {
                if (app) {
                    let custom_filters = app.filters.find(x => x.field === field);
                    let filteredValue = custom_filters.values;
                    if (custom_filters.type === 'multiple') {

                        custom_filters.selected.forEach(s => {
                            filteredValue = filteredValue.filter(y => y.name !== s)
                        });
                    } else if (custom_filters.type === 'multiple_price') {

                        custom_filters.selected.forEach(s => {
                            filteredValue = filteredValue.filter(y => {
                                if (y.min !== s[0] && y.count > 0) {
                                    return y;
                                }
                            })
                        });
                    }
                    return filteredValue
                }
            },

            getSelectedFiltersCount: function (selected, field) {

                let filter = app.filters.find(x => x.field === field);
                let cat = undefined;
                if (filter.type === 'multiple') {
                    cat = filter.values.find(y => y.name === selected);
                } else if (filter.type === 'multiple_price') {
                    cat = filter.values.find(y => {
                        if (y.min === selected[0] && y.max === selected[1]) {
                            return y;
                        }
                    });
                }
                if (cat !== undefined)
                    return cat.count;
                else
                    return 0
            },

            pushFilter: function (field) {

                let selectedFilter = [];

                //to append filter
                if (field === undefined) {
                    selectedFilter = app.filters.filter(x => x.selected.length > 0);
                }
                //to clear filter
                else {
                    selectedFilter = app.filters.filter(x => x.selected.length > 0 && x.field !== field);
                }

                um.clearFilterParams();
                let res;

                let stateObj = '';
                if (selectedFilter.length > 0) {
                    selectedFilter.forEach(f => {
                        // let res = um.withFilters(f.title, f.selected);
                        // stateObj = res.currentUrl;
                        if (f.type === 'multiple_price') {

                            if(f.selected.length > 1) f.selected.shift();               /* for single selection (radio) */

                            res = um.withNumericFilters(f.title, f.selected)
                        } else if (f.type === 'multiple' || f.type === 'singleStatic') {
                            res = um.withFilters(f.title, f.selected.map(x => {
                                return encodeURIComponent(x)
                            }))
                        }
                        stateObj = res.currentUrl;

                    });
                } else {
                    um.clearFilterParams();
                    stateObj = um.getCurrentUrl();
                }

                stateObj = stateObj.replace(/%20/g, '+');
                stateObj = stateObj.replace(/%2C/g, ',');
                // app.sliderChanged = true;
                // app.sliderChange();
                app.search(0);
                history.pushState(stateObj, 'filter', stateObj);
                // app.resetSlider();
            },

            filterAnalytics: function (pos, fName, fVal) {
                if (fVal !== false) {
                    // ga.recordFilterEvent(pos, `${fName} : ${fVal}`);
                    ga.recordFilterEvent(`${fName} : ${fVal}`,false);
                }
            },

            clearFilters: function (field) {

                if (field) {
                    app.filters
                        .filter(x => x.field === field)
                        .forEach(x => x.selected = []);
                    app.pushFilter(field);
                } else {
                    app.filters.forEach(x => {
                        if (x.type === 'multiple' || x.type === 'multiple_price' || x.type === 'singleStatic')
                            x.selected = [];
                    });
                    um.clearFilterParams();
                    app.includeOutOfStock = false;
                    let stateObj = um.getCurrentUrl();
                    history.pushState(stateObj, 'filter', stateObj);
                    app.sliderChanged = false;
                    app.search(0);
                }
            },

            emptyPushedFilters: function () {
                app.filters.forEach(f => {
                    f.selected = [];
                })
            },

            goToTop: function () {
                setTimeout(() => {
                    window.scroll({
                        top: 0,
                        left: 0,
                        behavior: 'smooth'
                    });
                }, 50);
            },

            setSidebarSticky: function () {
                let header = document.querySelector('header');
                let footer = document.querySelector('footer');
                setTimeout(() => {
                    sticky = new StickySidebar('#STbar', {
                        containerSelector: '#searchModal',
                        innerWrapperSelector: '.st-inner-filter',
                        topSpacing: header ? header.offsetHeight - 20 : 0,
                        bottomSpacing: footer ? footer.offsetHeight - 50 : 0,
                        minWidth: 500,
                        resizeSensor: true
                    });
                }, 50);

            },

            currencyChange: function () {

                if (Currency) {
                    app.activeCurrency = Currency.currentCurrency;

                    let res = um.parseUrl(window.location.href);
                    let range = res.ranges;
                    if (range && (JSON.stringify(range) !== '{}')) {
                        app.sliderValue[0] = app.convertPrice(parseFloat(range.Price.from));
                        app.sliderValue[1] = app.convertPrice(parseFloat(range.Price.to));
                        this.$refs.slider.setValue(app.sliderValue);
                        this.$refs.mobileSlider[0].setValue(app.sliderValue);
                    } else {
                        app.sliderValue[0] = app.convertPrice(parseFloat(app.sliderMin));
                        app.sliderValue[1] = app.convertPrice(parseFloat(app.sliderMax));
                    }

                    switch (app.activeCurrency) {
                        case 'INR':
                            app.currencySymbol = "RS. ";
                            break;
                        case 'USD':
                        case 'AUD':
                        case 'SGD':
                        case 'CAD':
                            app.currencySymbol = "$";
                            break;
                        case 'EUR':
                            app.currencySymbol = "€";
                            break;
                        case 'GBP':
                            app.currencySymbol = "£";
                            break;
                        case 'LKR':
                            app.currencySymbol = "RS ";
                            break;
                        case 'SAR':
                            app.currencySymbol = "SR";
                            break;
                        case 'KWD':
                            app.currencySymbol = "KD";
                            break;
                        case 'AED':
                            app.currencySymbol = "DHS. ";
                            break;
                    }
                }
            },

            isDeviceMobile: function () {
                return window.matchMedia("only screen and (max-width: 760px)").matches;
            },

            isDeviceTablet: function () {
                return window.matchMedia("only screen and (max-width: 1024px)").matches;
            },

            isDeviceIPad: function () {
                return window.matchMedia("only screen and (max-width: 1020px)").matches;
            },

            resetDataProperties: function () {
                app.results.length = 0;
                app.isOpen = false;
                app.isCollectionPage = false;
                app.isSearchPage = false;
                app.loader = true;
                app.showWaitMsg = false;
                app.emptyPushedFilters();
                if (app.sorts) app.activeSortLabel = app.sorts[0].label;
                app.query = '';
                app.collectionPageToOpen = '';
                app.includeOutOfStock = false;
                um.clearAllParams();
                app.resetSlider();
                app.goToTop();
            },

            openSearchModal: function () {
                /***
                 * Place search layout just after the main content
                 * Set isOpen to true
                 * Hide the main content
                 */
                let searchModalContainer = document.querySelector("#searchModalContainer");
                let main = document.querySelector("#MainContent");
                main.after(searchModalContainer);
                app.isOpen = true;
                document.getElementById("MainContent").style.display = "none";
                document.querySelector('body').classList.add('searchtap');
                app.crossElement.forEach(x => x.style.display = 'inline-block');
            },

            closeSearchModal: function () {
                /***
                 * If user directly landed on the search page then
                 * Redirect user to the homepage
                 * Else append the previous page
                 */
                if (app.isSearchPage === false) {
                    document.title = app.previousPageTitle;
                    document.getElementById("MainContent").style.display = "block";
                    history.pushState(app.previousPageURL, 'last url', app.previousPageURL);
                    app.resetDataProperties();
                    app.checkAndOpenCollectionsPage();
                    app.getSearchParamsFromUrl(window.location.href);
                    app.search(0);
                } else {
                    window.location.href = baseUrl;
                }
                app.crossElement.forEach(x => x.style.display = 'none');
            },

            checkAndOpenCollectionsPage: function () {

                /***
                 * If page is a collection page
                 * Then extract collection handle from the URL
                 * And show the collection page
                 */
                let isCachedPage = !!((location.origin === 'https://webcache.googleusercontent.com') && location.href.includes('https://www.koskii.com/collections/'))
                let coll_handle = isCachedPage ? location.href.split('https://www.koskii.com/collections/')[1].split('&')[0] : '';

                if ((location.pathname.startsWith('/collections/') && !location.pathname.includes('/products/')) || isCachedPage) {

                    let searchModalContainer = document.querySelector("#searchModalContainer");
                    // let collectionContainer = document.querySelector("#CollectionAjaxResult");
                    let collectionContainer = document.querySelector("#CollectionAjaxContent");
                    collectionContainer.before(searchModalContainer);
                    // document.getElementById("CollectionAjaxResult").style.display = "none";
                    document.getElementById("CollectionAjaxContent").style.display = "none";

                    app.isCollectionPage = true;
                    if(isCachedPage) app.collectionPageToOpen = coll_handle;

                    else {
                        let path = location.pathname.split('/');
                        app.collectionPageToOpen = path[path.length - 1];
                    }

                    um.setCollectionPage(app.isCollectionPage, app.collectionPageToOpen);
                    app.isOpen = true;
                    app.sliderChanged = false;
                    document.querySelector('body').classList.add('searchtap');
                    app.getSearchParamsFromUrl(window.location.href, isCachedPage);
                }
            },

            closeCollectionsPage: function () {
                app.resetDataProperties();
                um.setCollectionPage(app.isCollectionPage, app.collectionPageToOpen);
            },

            handleKeyup: function (searchElement) {


                if (searchElement.value.trim().length > 0) {
                    if (app.isCollectionPage) {
                        app.closeCollectionsPage();
                        app.sliderChanged = false;
                        app.resetSlider();
                    }
                    if (!app.isOpen) app.openSearchModal();
                    app.query = searchElement.value.trim();
                    document.title = app.query + "-Koskii";
                    // app.sliderChanged = false;
                    app.sliderValue = [app.sliderMin, app.sliderMax];
                    um.clearRangerParams();
                    let stateObj = um.getCurrentUrl();
                    if (app.query) history.pushState(stateObj, 'range', stateObj);
                    // if(app.filterCount === 0)app.search(0);
                    app.search(0);
                    app.pushQuery();
                    // app.resetSlider();
                } else if (!app.isCollectionPage) {
                    app.closeSearchModal();
                }
            },

            sliderChange: function (value, index) {
                app.sliderChanged = true;
                app.filterAnalytics('left', 'Price', app.sliderValue);
                // um.clearFilterParams();
                um.clearRangerParams();
                let res;

                let stateObj = '';
                res = um.withRange('Price', app.revertPrice(app.sliderValue[0]), app.revertPrice(app.sliderValue[1]));
                stateObj = res.currentUrl;

                stateObj = stateObj.replace(/%20/g, '+');
                stateObj = stateObj.replace(/%2C/g, ',');
                history.pushState(stateObj, 'filter', stateObj);
                app.showSliderReset = true;
                app.search(0);
            },

            sliderInputChangeMin: function (event) {
                if (event.target.value.trim() === "") {
                    return
                }
                //  app.sliderChange();
            },

            sliderInputChangeMax: function (event) {
                if (event.target.value.trim() === "") {
                    return
                }
                //  app.sliderChange();
            },

            setSlider: function () {

                app.sliderValue[0] = app.sliderValue[0] < app.sliderMin || app.sliderValue[0] > app.sliderMax ? app.sliderMin : app.sliderValue[0];
                app.sliderValue[1] = app.sliderValue[1] > app.sliderMax || app.sliderValue[1] < app.sliderMin ? app.sliderMax : app.sliderValue[1];

                // if(window.matchMedia("only screen and (max-width: 834px)").matches) app.$refs.mobileSlider.setValue(app.sliderValue);
                //  else  app.$refs.slider.setValue(app.sliderValue);
                app.$refs.mobileSlider[0].setValue(app.sliderValue);
                app.$refs.slider.setValue(app.sliderValue);

                app.sliderChange();
            },

            resetSlider: function () {
                app.sliderValue = [app.sliderMin, app.sliderMax];
                um.clearRangerParams();
                let stateObj = um.getCurrentUrl();
                app.showSliderReset = false;
                if (app.query) history.pushState(stateObj, 'filter', stateObj);
                if (app.filterCount === 0) app.search(0);
            },

            convertPrice: function (amt) {
                return (Currency && Currency.currentCurrency) ? Math.round(Currency.convert(amt, 'INR', Currency.currentCurrency)) : amt;
            },

            revertPrice: function (amt) {
                return (Currency && Currency.currentCurrency) ? Math.round(Currency.convert(amt, Currency.currentCurrency, 'INR')) : amt;
            },

            mounted() {
                try {

                    app.init();
                    /***
                     * Checking for currency upto 10 seconds
                     * if not found then clear the timeout
                     */
                    const maxIntervalAttempt = 50;
                    let currentIntervalAttempt = 1;

                    let currencyCheckInterval = setInterval(() => currencyChecker(), 200);

                    const currencyChecker = () => {
                        currentIntervalAttempt++;

                        if (currentIntervalAttempt > maxIntervalAttempt) {
                            clearInterval(currencyCheckInterval);
                        }

                        if (Currency !== undefined) {
                            let currency = Currency.currentCurrency;
                            if (currency) {
                                clearInterval(currencyCheckInterval);
                                app.currencyChange();
                                if(app.isOpen) app.search(0);
                            }
                        }
                    }

                    /***
                     * Input type event added on every search box
                     */

                    app.searchBoxSelector.forEach(searchElement => {
                        searchElement.addEventListener('input', (e) => {
                            e.preventDefault();
                            app.handleKeyup(searchElement);
                        })

                        searchElement.addEventListener('focus', (e) => {
                            ga.recordSearchStartEvent();
                        })
                    });

                    app.crossElement.forEach(x=> {
                        x.addEventListener('click', () => {
                            app.query = "";
                            app.searchBoxSelector.forEach(el => el.value = app.query);
                            app.pushQuery();
                            app.crossElement.forEach(x => x.style.display = 'none');
                            app.closeSearchModal();
                        })
                    });

                    /***
                     * Popstate event added
                     * If previous page is a search page then close collection page and open search page
                     * Else close search page and open collection page
                     */
                    window.addEventListener('popstate', function (e) {
                        if (app.isOpen) {
                            if (e.state) {
                                if (location.pathname.startsWith('/collections/') && app.isCollectionPage === false) {
                                    app.closeSearchModal();
                                    app.checkAndOpenCollectionsPage();
                                } else if (location.pathname.startsWith('/search') && app.isCollectionPage === true) {
                                    app.closeCollectionsPage();
                                    app.openSearchModal();
                                }
                            }
                            app.getSearchParamsFromUrl(e.state);
                            app.search(0);
                        }
                    });

                    /***
                     * Window scroll event added
                     */
                    window.addEventListener('scroll', () => {
                        if (app.isOpen) {

                            app.backToTop = window.scrollY >= 150;

                            if (app.isDeviceMobile()) {
                                if (window.scrollY > app.scrollVal + 200) {
                                    // app.searchBoxSelector.forEach(searchElement => searchElement.blur());
                                }
                            }

                            let scrollHeight = 1200;

                            if (app.isDeviceMobile() || app.isDeviceTablet()) scrollHeight = 800;

                            if (window.scrollY > scrollHeight + app.scrollVal) {
                                if (app.totalHits > app.currOffset + app.pageSize) {
                                    app.loadMore();
                                }
                                app.scrollVal = window.scrollY;
                            }
                            /***
                             * Adding sticky class after certain height
                             */
                            let header = document.querySelector('header');
                            let searchModal = document.getElementById("searchModalContainer");
                            let footer = document.querySelector('footer');
                            let stickyBar = document.getElementById("STbar");
                            if (header && footer && searchModal && stickyBar) {
                                if (window.scrollY > header.offsetHeight && window.scrollY < (searchModal.offsetHeight - header.offsetHeight - footer.offsetHeight)) {
                                    stickyBar.classList.add('sticky');
                                } else {
                                    stickyBar.classList.remove('sticky');
                                }
                            }
                        }
                    });

                    /***
                     * Currency change handler
                     * And check for Currency object every second
                     */
                    let currencySelectBox = document.querySelectorAll('select[name="currencies"]');

                    currencySelectBox.forEach(box => {
                        box.addEventListener('change', () => {
                            setTimeout(() => {
                                app.currencyChange();
                                if (app.isOpen) app.search(0);
                            }, 1000);
                        });
                    });

                } catch (error) {
                    console.error('SearchTap Mount Error', error);
                    app.errorEncountered = true;
                }
            }
        },

        computed: {},

        filters: {

            truncate: function (text, length) {
                const clamp = '...';
                length = length || 30;
                if (text.length <= length) return text;
                let tcText = text.slice(0, length - clamp.length);
                return tcText + clamp;
            },

            numberWithComma: function (number) {
                return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            },
        },
    });

    app.mounted();
});



// WEBPACK FOOTER //
// ./src/main.js